"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'See details': 'See details'
        }
    },
    'es': {
        'translation': {
            'See details': 'Ver detalles'
        }
    },
    'cs': {
        'translation': {
            'See details': 'Detaily'
        }
    },
    'zh': {
        'translation': {
            'See details': '细节'
        }
    },
    'he': {
        'translation': {
            'See details': 'פרטים נוספים'
        }
    }
};
